import { IModel } from '../@types/models/model';
import coreFields from './helpers/coreFields';

const ChemCompound: IModel = {
  title: 'Chemical compounds',
  apiPath: 'chem/compounds',
  forms: {
    default: {
      fields: ['id'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'symbol', 'title', 'composition_wt_percent', 'composition_wt_percent_lower', 'composition_wt_percent_higher'],
      hidden: ['id', 'composition_wt_percent_lower', 'composition_wt_percent_higher']
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'Title',
      source: 'title',
      ttoken: 'chem:elements.title',
      type: 'text',
      filter: true,
    },
    {
      title: 'Symbol',
      source: 'symbol',
      ttoken: 'chem:elements.symbol',
      type: 'text',
      filter: true,
    },
    {
      title: 'Composition (wt%)',
      source: 'composition_wt_percent',
      ttoken: 'chem:elements.composition_wt_percent',
      type: 'text',
      filter: true,
    },
    {
      title: 'Composition lower (wt%)',
      source: 'composition_wt_percent_lower',
      ttoken: 'chem:elements.composition_wt_percent_lower',
      type: 'numeric',
      filter: true,
    },
    {
      title: 'Composition higher (wt%)',
      source: 'composition_wt_percent_higher',
      ttoken: 'chem:elements.composition_wt_percent_higher',
      type: 'numeric',
      filter: true,
    }
  ],
};

export default ChemCompound;
